import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function OwnerLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/admin/login", { email, password });
      toast.success("Welcome back.");
      navigate("/owner-cabinet/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="owner-login-page" className="min-h-screen bg-[#0B0F19] flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute inset-0 ici-grid-bg-dark opacity-40 pointer-events-none" />
      <div className="absolute inset-0 ici-radial pointer-events-none" />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#151A26]/80 backdrop-blur-xl p-8 text-slate-100">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-md bg-[#0055FF] flex items-center justify-center"><Lock className="w-4 h-4 text-white" /></div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-slate-400">Owner Cabinet</div>
            <div className="font-display text-xl font-bold text-white">InterCorp Industries</div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Email</Label>
            <Input data-testid="owner-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white/5 border-white/10 text-white" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-400">Password</Label>
            <Input data-testid="owner-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-white/5 border-white/10 text-white" />
          </div>
          <Button data-testid="owner-login-submit" type="submit" disabled={loading} className="w-full h-11 bg-[#0055FF] hover:bg-[#0044CC]">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </div>
        <div className="mt-6 text-[11px] text-slate-500 border-t border-white/10 pt-4">
          Not in the public navigation. Owner and administrator access only.
        </div>
      </form>
    </div>
  );
}
